import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MyMatchesPage } from './my-matches.page';

const routes: Routes = [
    {
        path: '',
        component: MyMatchesPage,
        children: [
            {
                path: 'individual',
                loadChildren: () => import('../matches/matches.module').then(m => m.MatchesPageModule),
                title: 'Individual Matches'
            },
            {
                path: 'ties',
                loadChildren: () => import('../ties/tie-list/tie-list.module').then(m => m.TiesListPageModule),
                title: 'Team Matches'
            },
            {
                path: 'featured-events',
                loadChildren: () => import('../featured-events/featured-events.module').then(m => m.FeaturedEventsModule),
                title: 'Featured Events'
            },
            {
                path: '',
                redirectTo: '/individual',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MyMatchesPageRoutingModule { }
